export default __webpack_public_path__ + "assets/images/6a02134204e286c295a98a91d2f72a9c.svg";